import "./ServiceAreas.module.css";
import Header from "@/reusable_sections/Header";
import ServiceAreaIntro from "./sections/ServiceAreaIntro";
import NeighborhoodServiceAreas from "./sections/NeighborhoodServiceAreas";
import ConsultationCallToAction from "./sections/ConsultationCallToAction";
import EstimateRequestForm from "./sections/EstimateRequestForm";
import Footer from "@/reusable_sections/Footer";
export default function ServiceAreasPage() {
  return <div>
      <Header />
      <ServiceAreaIntro />
      <NeighborhoodServiceAreas />
      <EstimateRequestForm />
      <ConsultationCallToAction />
      <Footer />
    </div>;
}